
import { Component, Vue } from 'vue-property-decorator'
import resolveConfig from 'tailwindcss/resolveConfig'
import { Options } from '../@types/Slide'
import { clone } from 'lodash'

const {
  theme: { colors: defaultColors }
} = resolveConfig(require('@/../tailwind.config.js'))

const colors = Object.entries(defaultColors).reduce(
  (object, [colorKey, colorValue]) => {
    if (typeof colorValue === 'string') {
      object[colorKey] = colorValue
    } else {
      for (let colorShade in defaultColors[colorKey]) {
        object[`${colorKey}-${colorShade}`] =
          defaultColors[colorKey][colorShade]
      }
    }
    return object
  },
  {}
)

@Component
export default class Colored extends Vue {
  /**
   * Transformed options.
   */
  public __options: any = {}

  /**
   * Change color options to tailwind.
   */
  public colorOptionsToColors(options: any) {
    for (let i in options) {
      if (options[i] !== null) {
        if (Array.isArray(options[i])) {
          if (i.toLowerCase().includes('color')) {
            for (let j in options[i]) {
              options[i][j] = this.getColor(options[i][j])
            }
          } else {
            options[i] = this.colorOptionsToColors([...options[i]])
          }
        } else if (typeof options[i] === 'object') {
          options[i] = this.colorOptionsToColors({ ...options[i] })
        } else if (i.toLowerCase().includes('color')) {
          options[i] = this.getColor(options[i])
        }
      }
    }

    return options
  }

  /**
   * Get color from Tailwind.
   */
  public getColor(colorCode: string = null) {
    return colors[colorCode] || colorCode
  }
}
